import {
  BookingContext,
  FlightBookingStep,
  NavigatorRoutes,
  PageStatus,
  UserIdentityPreference,
  ErrorResponseStatus,
  TravelClassOption,
  FlightTypeOption,
  Currency,
  ErrorMessage,
  BagType,
  PaymentStatus,
} from '~/types';

export const STATUS: PageStatus = {
  IDLE: 'idle',
  RUNNING: 'running',
  READY: 'ready',
  SUCCESS: 'success',
  ERROR: 'error',
  LOGIN_REQUIRED: 'login_required',
};

export const BOOKING_STEP: FlightBookingStep = {
  FLIGHT_SEARCH: 'flight_search',
  PASSENGER_DETAILS_CAPTURING: 'passenger_details_capturing',
  BAGGAGE_ADDITION: 'baggage_addition',
  PAYMENT_REQUESTED: 'payment_requested',
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_FAILURE: 'payment_failed',
  BOOKING_COMPLETED: 'booking_completed',
  PAYMENT_CONFIRMATION: 'payment_confirmation',
};

export const USER_IDENTITY_PREFERENCE: UserIdentityPreference = {
  REGISTER: 'registered',
  GUEST: 'guest',
  NOT_SELECTED: 'not_selected',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot_password',
};

export const ERROR_RESPONSE_STATUS: ErrorResponseStatus = {
  UNKOWN_ERROR: 'unknown_error',
  INTERNAL_STORAGE_ERROR: 'internal_storage_error',
  PAYMENT_FAILED: 'payment_failed',
  PAYMENT_REFUNDED: 'payment_refunded',
  GDS_CREATE_ORDER_FAILURE: 'gds_create_order_failer',
  GDS_PRICE_CHANGED: 'gds_price_change',
  INTERNAL_COMM_ERROR: 'internal_comm_error',
  PRICE_CHANGED: 'price_changed',
}

export const ERROR_MESSAGE: ErrorMessage = {
  UNKOWN_ERROR: 'unknown_error',
  INTERNAL_STORAGE_ERROR: 'internal_storage_error',
  PAYMENT_FAILED: 'payment_failed',
  PAYMENT_REFUNDED: 'payment_refunded',
  GDS_CREATE_ORDER_FAILURE: 'gds_create_order_failer',
  GDS_PRICE_CHANGED: 'gds_price_change',
  INTERNAL_COMM_ERROR: 'internal_comm_error',
  PAGE_NOT_FOUND: 'page_not_found',
  PRICE_CHANGED: 'price_changed',
}

export const NAVIGATOR_ROUTES: NavigatorRoutes = {
  SearchWidget: 'flight-search-widget',
  OfferList: 'flight-offers-list',
}

export const BOOKING_CONTEXT: BookingContext = {
  FLIGHT: 'flight',
  FLIGHT_ITINERARY: 'flight_itinerary',
  FLIGHT_HOTEL: 'flight_hotel',
  FLIGHT_HOTEL_ITINERARY: 'flight_hotel_itinerary',
}

export const TRAVEL_CLASS: TravelClassOption = {
  ECONOMY: 'Economy',
  PREMIUM_ECONOMY: 'Premium Economy',
  BUSINESS: 'Business',
  FIRST: 'First',
}

export const PAYMENT_STATUS: PaymentStatus = {
  CANCELLED: 'canceled',
  FAILED: 'failed',
  SUCCESS: 'success',
}

export const FLIGHT_TYPE: FlightTypeOption = {
  ONE_WAY: 'oneway',
  RETURN: 'return',
}


export const BAG_TYPE: BagType = {
  CHECKED_BAG: 'CHECKED_BAG',
}
export const UNLICENSED_ORIGIN = 'notLicenced';

export const EURO_SIGN = '€';
export const USD_SIGN = '$';
export const ZAR_SIGN = 'R';
export const GBP_SIGN = '£';
export const PLN_SIGN = 'zł';
export interface SupportedCurrency {
  USD: Currency,
  EUR: Currency,
  ZAR: Currency,
  GBP: Currency,
  PLN: Currency,
}

export const CURRENCY: SupportedCurrency = {
  USD: 'USD',
  EUR: 'EUR',
  ZAR: 'ZAR',
  GBP: 'GBP',
  PLN: 'PLN',
}

export const CURRENCY_SIGNS: Record<string, string> = {
  [CURRENCY.EUR]: EURO_SIGN,
  [CURRENCY.USD]: USD_SIGN,
  [CURRENCY.ZAR]: ZAR_SIGN,
  [CURRENCY.GBP]: GBP_SIGN,
  [CURRENCY.PLN]: PLN_SIGN,
};

export const PAGE_SIZE = 10;
export const MAX_OFFERS = 250;
export const SELECTED_CURRENCY_STORAGE_KEY = 'selectedCurrency';